import './styles.scss'
import React, { useState } from 'react'

const HorizontalScroll = ({ direction, onMouseMoveCapture }) => {
  const [internalId, setIntervalId] = useState(null)
  const directionArrow = {
    left: '<',
    right: '>'
  }

  const onMouseOver = () => {
    if (internalId) clearInterval(internalId)

    const id = setInterval(() => {
      onMouseMoveCapture()
    }, 100)

    setIntervalId(id)
  }

  return (
    <div
      className={`chevronArrow ${direction}`}
      onMouseEnter={onMouseOver}
      onMouseLeave={() => {
        clearInterval(internalId)
        setIntervalId(null)
      }}

    >
      <strong className={direction}>{directionArrow[direction] || ''}</strong>
    </div>
  )
}

export default HorizontalScroll
